import { RootStateOrAny, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { MenuState, PaletteAppearance } from './reducer';

export const selectMenu = ({ menu }: RootStateOrAny): MenuState => menu;

/** Components Tab */
export const selectComponentsSearch = createSelector(
  selectMenu,
  ({ componentsSearch }) => componentsSearch,
);
export const useComponentsSearch = () => useSelector(selectComponentsSearch);

/** Palette */
export const selectPaletteAppearence = createSelector(
  selectMenu,
  ({ paletteAppearance }: MenuState) => paletteAppearance,
);
export const selectIsPalettePinned = createSelector(
  selectMenu,
  ({ paletteAppearance }: MenuState) => paletteAppearance === PaletteAppearance.PINNED,
);
export const selectIsPaletteLayersHidden = createSelector(
  selectMenu,
  ({ hiddenLayers }: MenuState) => hiddenLayers,
);
export const usePaletteAppearence = () => useSelector(selectPaletteAppearence);
export const useIsPalettePinned = () => useSelector(selectIsPalettePinned);
export const useIsPaletteLayersHidden = () => useSelector(selectIsPaletteLayersHidden);

export const selectPaletteTab = createSelector(selectMenu, ({ paletteTab }) => paletteTab);
export const usePaletteTab = () => useSelector(selectPaletteTab);

export const usePlacementMode = () =>
  useSelector(
    createSelector(selectMenu, (state) => ({
      placementMode: state.placementMode,
      previewSelector: state.previewSelector,
      previewSelectorLocation: state.previewSelectorLocation,
    })),
  );

/** Tab */
export const selectToolbarTab = createSelector(selectMenu, (state) => ({
  activeTab: state?.toolboxTab,
  forcePlacementsTab: state?.forcePlacementsTab,
}));
export const useToolboxTab = () => useSelector(selectToolbarTab);
